import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {ApplicationProcessComponent} from './application-process.component';

const routes: Routes = [
    {
        path: '',
        component: ApplicationProcessComponent,
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ApplicationProcessRoutingModule { }
